import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";
import { I18N_LOCALE_ROOT } from "./constants";

interface ErrorStateProps {
  errorMessage?: string;
  onClose: () => void;
}

export const ErrorState = ({ errorMessage, onClose }: ErrorStateProps) => (
  <>
    <Modal.Body>
      <div className="mx-auto mt-16 max-w-sm text-center">
        <Icon type="68-error-grey" size={68} className="mb-10 !w-14" />

        <Typography.TitleLg color="text-darkest">
          {t(`${I18N_LOCALE_ROOT}.error.title`)}
        </Typography.TitleLg>

        <div className="mt-3">
          <Typography.BodyMd
            color="text-subtle"
            weight="normal"
            size="text-base"
          >
            {errorMessage || t(`${I18N_LOCALE_ROOT}.error.subtitle`)}
          </Typography.BodyMd>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer className="mt-5">
      <div className="flex justify-center">
        <Button variant="circle" large full onClick={onClose}>
          {t(`${I18N_LOCALE_ROOT}.error.close_button`)}
        </Button>
      </div>
    </Modal.Footer>
  </>
);
